import { useMemo } from 'react';

import { useRecoilValue } from 'recoil';

import { useInstantPacket } from 'lib/hooks/queries/instantPacket/useInstantPacket';

import { currentPractice } from 'components/practice/practiceState';
import AgTablePage from 'components/shared/AgTablePage/AgTablePage';
import { withErrorBoundary } from 'components/shared/Error/Boundary';

import HeaderActions from './components/HeaderActions';
import { DEFAULT_FILTERS, defaultColumns } from './lib/helper';

const FormPacket = () => {
  const practice = useRecoilValue(currentPractice);

  const columnDefs = useMemo(() => defaultColumns(practice?.timezone), [practice?.timezone]);
  return (
    <AgTablePage
      defaultColumns={columnDefs}
      defaultFilters={DEFAULT_FILTERS}
      useData={useInstantPacket}
      name="instant_packets"
      title="Patient Forms"
      rowStyle={{ cursor: 'pointer' }}
      actions={HeaderActions}
      queryParams={{
        withAl: { withAllForms: true, withPatient: true, withProvider: true }
      }}
    />
  );
};

export default withErrorBoundary(FormPacket);
